import axios from "axios";
import { API_URL } from "../apiurl";
import {
  UPLOAD_EXCEL_DATA_MUTATION,
  UPSERT_EXCEL_DATA_MUTATION,
  UPDATE_EXCEL_DATA_MUTATION,
  DELETE_EXCEL_DATA_MUTATION,
  DELETE_EXCEL_DATA_BY_REPORT_MUTATION,
} from "./mutation";
import {
  GET_EXCEL_DATA_BY_REPORT_QUERY,
  GET_EXCEL_DATA_BY_ID_QUERY,
} from "./query";

const getAuthToken = () => {
  const user = JSON.parse(localStorage.getItem("maxUser") || "{}");
  return user?.token || "";
};

const getUserId = () => {
  const user = JSON.parse(localStorage.getItem("maxUser") || "{}");
  return user?.id || "";
};

export const uploadExcelDataAPI = async (reportId, tableId, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/graphql`,
      {
        query: UPLOAD_EXCEL_DATA_MUTATION,
        variables: { reportId, tableId, data },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.errors) {
      throw new Error(response.data.errors[0].message);
    }

    return response.data.data.uploadExcelData;
  } catch (error) {
    console.error("Error uploading excel data:", error);
    throw error;
  }
};

export const upsertExcelDataAPI = async (reportId, tableId, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/graphql`,
      {
        query: UPSERT_EXCEL_DATA_MUTATION,
        variables: { reportId, tableId, data },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.errors) {
      throw new Error(response.data.errors[0].message);
    }

    return response.data.data.upsertExcelData;
  } catch (error) {
    console.error("Error upserting excel data:", error);
    throw error;
  }
};

export const updateExcelDataAPI = async (id, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/graphql`,
      {
        query: UPDATE_EXCEL_DATA_MUTATION,
        variables: { id, data },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.errors) {
      throw new Error(response.data.errors[0].message);
    }

    return response.data.data.updateExcelData;
  } catch (error) {
    console.error("Error updating excel data:", error);
    throw error;
  }
};

export const deleteExcelDataAPI = async (id) => {
  try {
    const response = await axios.post(
      `${API_URL}/graphql`,
      {
        query: DELETE_EXCEL_DATA_MUTATION,
        variables: { id },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.errors) {
      throw new Error(response.data.errors[0].message);
    }

    return response.data.data.deleteExcelData;
  } catch (error) {
    console.error("Error deleting excel data:", error);
    throw error;
  }
};

export const deleteExcelDataByReportAPI = async (reportId, tableId = null) => {
  try {
    const response = await axios.post(
      `${API_URL}/graphql`,
      {
        query: DELETE_EXCEL_DATA_BY_REPORT_MUTATION,
        variables: { reportId, tableId },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.errors) {
      throw new Error(response.data.errors[0].message);
    }

    return response.data.data.deleteExcelDataByReport;
  } catch (error) {
    console.error("Error deleting excel data by report:", error);
    throw error;
  }
};

export const getExcelDataByReportAPI = async (reportId, tableId = null) => {
  try {
    const response = await axios.post(
      `${API_URL}/graphql`,
      {
        query: GET_EXCEL_DATA_BY_REPORT_QUERY,
        variables: { reportId, tableId },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.errors) {
      throw new Error(response.data.errors[0].message);
    }

    return response.data.data.getExcelDataByReport;
  } catch (error) {
    console.error("Error fetching excel data:", error);
    throw error;
  }
};

export const getExcelDataByIdAPI = async (id) => {
  try {
    const response = await axios.post(
      `${API_URL}/graphql`,
      {
        query: GET_EXCEL_DATA_BY_ID_QUERY,
        variables: { id },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.errors) {
      throw new Error(response.data.errors[0].message);
    }

    return response.data.data.getExcelDataById;
  } catch (error) {
    console.error("Error fetching excel data by id:", error);
    throw error;
  }
};
